// extracted by mini-css-extract-plugin
module.exports = {"columns":"Dashboard-columns-ba863bef87da67c002b059aeb767d53b"};